import { useContext } from "react";
import type { PubSubDefinition } from "@huub-web/utils";

import {
  PubSubContext,
  type PubSubContextState,
} from "../contexts/PubSubContext";
import type { PubSubMap } from "../types";

export const usePubSub = <
  T extends PubSubDefinition = PubSubMap,
>(): PubSubContextState<T> => {
  const context = useContext(PubSubContext);
  if (!context) {
    throw new Error("usePubSub must be used within a PubSubProvider");
  }

  return context;
};

export const useMaybePubSub = <T extends PubSubDefinition = PubSubMap>():
  | PubSubContextState<T>
  | undefined => useContext(PubSubContext);
